(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["as-recently-viewed"]) return;
  try {
    
  if (!customElements.get('as-recently-viewed-page')) {
    class RecentlyViewedPage extends HTMLElement {
      connectedCallback() {
        this.storageKey = 'as_recent_products_v1';
        this.grid = this.querySelector('[data-recent-grid]');
        this.status = this.querySelector('[data-recent-status]');
        this.empty = this.querySelector('[data-recent-empty]');
        this.retry = this.querySelector('[data-recent-retry]');
        this.listenerController = new AbortController();
        const signal = this.listenerController.signal;
        this.retry.addEventListener('click', () => this.renderProducts(), { signal });
        window.addEventListener('storage', (event) => {
          if (event.key === null || event.key === this.storageKey) this.renderProducts();
        }, { signal });
        this.renderProducts();
      }

      disconnectedCallback() {
        this.listenerController?.abort();
        this.requestController?.abort();
      }

      getHandles() {
        try {
          const stored = JSON.parse(localStorage.getItem(this.storageKey) || '[]');
          if (!Array.isArray(stored)) return [];
          return [...new Set(stored.filter((handle) =>
            typeof handle === 'string' && /^[a-z0-9-]{1,120}$/.test(handle)
          ))].slice(0, 50);
        } catch (error) {
          return [];
        }
      }

      async renderProducts() {
        this.requestController?.abort();
        const controller = new AbortController();
        this.requestController = controller;
        this.status.textContent = this.dataset.loadingMessage;
        this.status.hidden = false;
        this.retry.hidden = true;
        this.empty.hidden = true;
        this.grid.setAttribute('aria-busy', 'true');
        const handles = this.getHandles();
        const cards = new Array(handles.length);
        let nextIndex = 0;
        let failed = false;

        const loadNext = async () => {
          while (nextIndex < handles.length && !controller.signal.aborted) {
            const index = nextIndex++;
            try {
              const url = new URL(this.dataset.productsUrl + encodeURIComponent(handles[index]), location.origin);
              url.searchParams.set('view', 'recently-viewed-card');
              const response = await fetch(url, { signal: controller.signal, headers: { Accept: 'text/html' } });
              if (response.status === 404 || response.status === 410) continue;
              if (!response.ok) throw new Error('Product could not be loaded');
              const html = new DOMParser().parseFromString(await response.text(), 'text/html');
              const card = html.querySelector('[data-as-recently-viewed-card]');
              if (card) cards[index] = document.importNode(card, true);
              else failed = true;
            } catch (error) {
              if (!controller.signal.aborted) failed = true;
            }
          }
        };
        await Promise.all(Array.from({ length: Math.min(handles.length, 6) }, loadNext));
        if (controller.signal.aborted || !this.isConnected) return;
        const loadedCards = cards.filter(Boolean);
        this.grid.replaceChildren(...loadedCards);
        this.grid.setAttribute('aria-busy', 'false');
        this.status.textContent = failed ? this.dataset.errorMessage : '';
        this.status.hidden = !failed;
        this.retry.hidden = !failed;
        this.empty.hidden = loadedCards.length > 0 || failed;
      }
    }
    customElements.define('as-recently-viewed-page', RecentlyViewedPage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.setupStickyStack();

      this.headerMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerMediaQueryHandler = () => {
        document.documentElement.classList.remove('as-mobile-header-hidden');
        this.setHeaderHeight();
      };
      this.headerMediaQuery.addEventListener('change', this.headerMediaQueryHandler);
      this.onSectionLoad = () => requestAnimationFrame(() => this.setupStickyStack());
      document.addEventListener('shopify:section:load', this.onSectionLoad);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    setupStickyStack() {
      this.stackResizeObserver?.disconnect();
      this.contactSection?.classList.remove('as-sticky-contact-section');
      this.announcementSection?.classList.remove('as-sticky-announcement-section');

      const groupSections = Array.from(document.querySelectorAll('.shopify-section-group-header-group'));
      this.contactSection = groupSections.find((section) => section.querySelector('[class^="ai-contact-bar-"]'));
      this.announcementSection = groupSections.find((section) => section.querySelector('.utility-bar'));

      this.contactSection?.classList.add('as-sticky-contact-section');
      this.announcementSection?.classList.add('as-sticky-announcement-section');
      this.header.classList.add('as-sticky-nav-section');

      this.updateStickyStack = () => {
        const contactHeight = this.contactSection?.getBoundingClientRect().height || 0;
        const announcementHeight = this.announcementSection?.getBoundingClientRect().height || 0;
        const navigationHeight = this.header.getBoundingClientRect().height;
        const stackHeight = contactHeight + announcementHeight + navigationHeight;

        document.documentElement.style.setProperty('--as-contact-height', `${contactHeight}px`);
        document.documentElement.style.setProperty('--as-announcement-height', `${announcementHeight}px`);
        document.documentElement.style.setProperty('--as-sticky-stack-height', `${stackHeight}px`);
        document.documentElement.style.setProperty('--header-bottom-position-desktop', `${stackHeight}px`);
      };

      this.stackResizeObserver = new ResizeObserver(this.updateStickyStack);
      [this.contactSection, this.announcementSection, this.header].filter(Boolean).forEach((section) => {
        this.stackResizeObserver.observe(section);
      });
      this.updateStickyStack();
    }

    disconnectedCallback() {
      document.documentElement.classList.remove('as-mobile-header-hidden');
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.headerMediaQuery.removeEventListener('change', this.headerMediaQueryHandler);
      document.removeEventListener('shopify:section:load', this.onSectionLoad);
      this.stackResizeObserver?.disconnect();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const current = Math.max(0, window.pageYOffset || document.documentElement.scrollTop);
      const headerFocus = document.activeElement?.closest('.shopify-section-group-header-group');
      const interacting = this.header.querySelector('details[open]') ||
        document.body.classList.contains('as-search-popover-open') || headerFocus;

      if (current <= 4 || interacting) {
        document.documentElement.classList.remove('as-mobile-header-hidden');
      } else if (Math.abs(current - this.currentScrollTop) >= 4) {
        document.documentElement.classList.toggle('as-mobile-header-hidden', current > this.currentScrollTop);
      } else {
        return;
      }

      this.currentScrollTop = current;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
